import { render } from "./IconTag.vue?vue&type=template&id=5491896f"
import script from "./IconTag.vue?vue&type=script&lang=js"
export * from "./IconTag.vue?vue&type=script&lang=js"

import "./IconTag.vue?vue&type=style&index=0&id=5491896f&lang=css"

import exportComponent from "/home/runner/work/night.nana7mi.link/night.nana7mi.link/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__